import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg md:text-xl font-bold text-foreground-950">
          漫画分类
        </h2>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line ml-1 align-middle"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex items-center justify-center px-4 py-3 rounded-lg bg-background-100 hover:bg-primary-100 transition-colors cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 whitespace-nowrap transition-colors">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}